
"use strict";

const applyWindowState = require("./applyWindowState");
const webChatConfig = require("./webChatConfig");
const webChatCommonApiUtils = require("./webChatCommonApiUtils");
const $ = require("jquery");

const processArrayResponse = (responseData, messageFrom) => {
  let events = responseData.events;
  for (const element of events) {
    let eventData = element;
    // Null should not come back in an event but putting check just in case.
    if (eventData !== null) {
      processResponse(JSON.parse(eventData),messageFrom);
    }
  }
};

const processResponse = (data, messageFrom) => {
  if (responseEvents[data.type]) {
    responseEvents[data.type].call(this, data, messageFrom);
  }
};

let responseEvents = {};

responseEvents.UserTyping = (data) => {
  applyWindowState.writeUserTypingMessageInDisplay(data.userDisplayName);
  console.log("**** USER TYPING ***");
};

responseEvents.MessageReceived = (data, messageFrom) => {
  updateUnreadMessagesCounter(data);

  let textToDisplay = data.text;

  // Check if message text contains warning for timeout.
  if (textToDisplay) {
    if (textToDisplay.indexOf("TIMED_OUT_WARNING") !== -1) {
      // Set flag to indicate time out warning received and user has not seen it yet.
      if (!webChatConfig.chatWindowOpen()) {
        webChatConfig.setWarningDisplayFlag(1);
      }
      applyWindowState.applyWindowState(
          webChatConfig.STATE_OPEN_TIMEOUT_WARNING()
      );
    }
    // Check if message text contains warning for timeout.
    else if (textToDisplay.indexOf("TIMED_OUT") !== -1) {
      console.log('timed out message recieved -> ', textToDisplay);
      // Set flag to indicate timed out message received and user has not seen it yet.
      if (!webChatConfig.chatWindowOpen()) {
        webChatConfig.setWarningDisplayFlag(2);
      }
      //_logout();
      // TODO - needs to be replaced with websocket disconnect.
      applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_TIMED_OUT());
    }
    // Check if message text contains Customer clearing Idle Timeout Warning Message.
    // Do not display this in Web Chat Client Window.
    else if (textToDisplay.indexOf("Customer does not wish to end chat") !== -1) {
      // Do nothing.
    } else if (textToDisplay.indexOf("SYSTEM: PIN sent") !== -1) {
      //Empty value of pin form
      $("#pinInput").val("");
      //Display pin panel
      setTimeout(() => {
        applyWindowState.hideElement("#pinNotVerified");
        applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_PIN_REQUEST());
        applyWindowState.writeTextMessageInDisplay("PIN Sent");
      }, 2000);
    } else if (textToDisplay.indexOf("SYSTEM: PIN Verified") !== -1) {
      applyWindowState.applyWindowState(webChatConfig.STATE_CLOSE_PIN_REQUEST());
      applyWindowState.writeTextMessageInDisplay("PIN Verified");
    } else if (textToDisplay.indexOf("SYSTEM: Invalid PIN: Incorrect token.") !== -1) {
      applyWindowState.showElement("#pinNotVerified");
    } else if (textToDisplay.indexOf("SYSTEM: Invalid PIN: Maximum retries count reached.") !== -1) {
      applyWindowState.applyWindowState(webChatConfig.STATE_CLOSE_PIN_REQUEST());
      applyWindowState.writeTextMessageInDisplay("PIN not verified.");
    } else if ((textToDisplay.indexOf("SYSTEM: Awaiting user reconnection") !== -1 || textToDisplay.indexOf("SYSTEM: Connection restored with user") !== -1)) {
      console.log(textToDisplay);
    } else {
      showMessageInClientDisplay(data, textToDisplay, messageFrom);
      // Store the session.
      webChatCommonApiUtils.storeWebChat();
    }
  }
  console.log("**** MESSAGE RECEIVED ***");
};

/**
 * If the Web Chat Client window is minimised but a chat is active and a message is received, update
 * the Notification icon with the number of unread messages.
 */
const updateUnreadMessagesCounter = (data) => {
  if (!webChatConfig.chatWindowOpen()) {
    let unreadMessagesCount = webChatConfig.unreadMessagesCount();
    if (!data.text.includes("SYSTEM:")) {
      unreadMessagesCount++;
      // Set unread messages count back in config file.
      webChatConfig.setUnreadMessagesCount(unreadMessagesCount);
      // Show number of unread messages in notification icon.
      applyWindowState.updateNotificationIcon();
    }
  }
};

/**
 * Write message from agent in Web Chat Client window.
 */
const showMessageInClientDisplay = (data, textToDisplay, messageFrom) => {
  let name = data.userDisplayName;
  // Check for URL's in message and add "target='_blank'" to ensure links open in a new Window
  textToDisplay = addTargetBlankToUrls(textToDisplay);
  let timeClass = "agentTime content67";
  // Show different class for Time if message is from agent.
  if (
      name !== null && messageFrom === "USER" &&
    (name === webChatConfig.userName() || name === "Anonymous" || name === "guest")
  ) {
    timeClass = "userTime content66";
  }
  applyWindowState.writeMessageInDisplay(name, textToDisplay, timeClass, messageFrom);
};

/**
 * Check text passed in to see if any URL's exist in it and add "target='_blank'"
 * to ensure links open in a new Window.
 */
const addTargetBlankToUrls = (text) => {
  if (text !== null && text.length > 0) {
    // Look for all occurrences of "href='" and replace them with "target='_blank' href='"
    text = text.replace(/href=/g, "target='_blank' href=");
  }
  return text;
};

responseEvents.Dropped = () => {
  console.log("**** DROPPED ***");
  // We only want to end on user side if there are no agents.  If there are at least one or more agents then
  // the drop is part of a transfer.
  if (webChatConfig.nbrConnectedAgents() === 0) {
    // Clear all intervals and Show Feedback Survey if Agent dropped the chat
    applyWindowState.clearAllEventIntervals();
    applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_FEEDBACK());
  }
};

responseEvents.UserEntered = (data) => {
  console.log("**** USER ENTERED ***");
  // Check if user type is not a Guest, then this means an agent/supervisor has joined the chat. We only want
  // to show this when it's part of a transfer and not when an agent initially joins a chat. Also increment
  // counter for number of agents connected.
  if (data.userType !== null && data.userType !== "GUEST") {
    let nbrConnectedAgents = webChatConfig.nbrConnectedAgents();
    nbrConnectedAgents++;
    webChatConfig.setNbrConnectedAgents(nbrConnectedAgents);
    console.log("* AGENTS Counter incremented to : " + nbrConnectedAgents);
    // If agents connected > 1 then this is a transfer or supervisor joining chat and so show agent entered chat.
    if (nbrConnectedAgents > 1) {
      // Write message to screen that agent has entered chat.
      applyWindowState.writeTextMessageInDisplay(
        "<div class='content30'>" +
          data.userDisplayName +
          " has entered the chat</div>"
      );
    }
    // Store the session as agent has entered.
    webChatCommonApiUtils.storeWebChat();
  }
  // Reset the Queue Flag and timer to stop polling queue.
  console.log(
    "1 - Clearing queueEventTimeout" + webChatConfig.queueEventTimeout
  );
  applyWindowState.clearQueueTimeout();
  webChatConfig.setAgentName(data.userDisplayName);
  applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_ACTIVE_WEB_CHAT());
};

responseEvents.UserExited = (data) => {
  console.log("**** USER EXITED ***");
  // If agent has left the chat, decrement counter so we can determine if this is a transfer or
  // just an agent ending the chat. Also show message that agent has left the chat.
  if (data.userType !== null && data.userType !== "GUEST") {
    let nbrConnectedAgents = webChatConfig.nbrConnectedAgents();
    nbrConnectedAgents--;
    webChatConfig.setNbrConnectedAgents(nbrConnectedAgents);
    console.log("* AGENTS Counter decremented to : " + nbrConnectedAgents);
    applyWindowState.writeTextMessageInDisplay(
      "<div class='content30'>" +
        data.userDisplayName +
        " has left the chat</div>"
    );
    // Store the session as agent has exited.
    webChatCommonApiUtils.storeWebChat();
  }

  // Only if number of agents connected is less than one, should we call the logout API. This user exited event
  // can happen as part of a transfer from one agent to another and so should not logout in that case. However
  // if no agents are left connected, then logout should be called to end the session and show the chat ended.
  console.log(
    "* AGENTS Connected to Chat : " + webChatConfig.nbrConnectedAgents()
  );
  if (webChatConfig.nbrConnectedAgents() === 0) {
    //_logout();
    // TODO - needs to be replaced with websocket disconnect.
    applyWindowState.applyWindowState(webChatConfig.STATE_OPEN_ENDED());
  }
};

responseEvents.LoggedOut = () => {
  // The following will clear out Weblogic Session but may close client window.
  applyWindowState.clearWebChatFromSession();
  applyWindowState.clearAllEventIntervals();
  console.log("**** USER LOGGED OUT ***");
};

const success = (responseData, messageFrom) => {
  if (responseData.events.constructor === Array) {
    processArrayResponse(responseData, messageFrom);
  } else {
    processResponse(responseData, messageFrom);
  }
};

const failure = () => {
  console.log("Error occurred");
};

module.exports = {
  failure: failure,
  success: success,
};